import { useMyBillings } from './useMyBillings'
import { useHasBusinesses } from '@/features/businesses/hooks/useHasBusinesses'

/** Estados de factura que cuentan como "pendiente de pago" para el aviso. */
const PENDING_STATUSES = ['PENDING', 'PARTIALLY_PAID']

/**
 * Número de facturas pendientes de pago del usuario (todos sus negocios), para
 * el aviso de la barra superior. Reutiliza `portalMyBillings` con `take: 1` —
 * solo interesa `totalItems` — y comparte la caché `cache-first`, así que no
 * repega al backend en cada navegación. Se desactiva sin negocios (403).
 */
export function usePendingBillingsCount() {
  const { hasBusinesses, loading: businessesLoading } = useHasBusinesses()
  const { totalItems, loading } = useMyBillings({
    take: 1,
    skip: 0,
    statusFilter: PENDING_STATUSES,
    disabled: !hasBusinesses,
  })

  return {
    count: hasBusinesses ? totalItems : 0,
    loading: businessesLoading || loading,
  }
}
